import PracticeLibraryBookmarkList from './PracticeLibraryBookmarkList';

export default PracticeLibraryBookmarkList;
